import React from "react";
import { DataGrid } from "@material-ui/data-grid";
import { useStyles } from "../styles";
import empty from "../../../../assets/images/empty-concessions.png";
import "../bookings.css";
import { useState } from "react";
import BookingDetails from "../BookingDetails";
import ConfirmDialog from "../ConfirmDialog";
import { Button } from "@material-ui/core";
import { useSelector } from "react-redux";
import { BOOKING_STATUS } from "../data";
import cubeApi from "../../../../api/cube";

const CancelledBookings = ({ selectedCubeId, loading, data, loadBooking }) => {
  const classes = useStyles();
  const [showDetails, setShowDetails] = useState(false);
  const [showApproveDialog, setShowApproveDialog] = useState(false);
  const [booking, setBooking] = useState({});

  const { jwt } = useSelector(state => state.user.user);

  const columns = [
    {
      field: "booking_id",
      headerName: "ID",
      width: 100
    },
    {
      field: "full_name",
      headerName: "Name",
      width: 200
    },
    {
      field: "phone_number",
      headerName: "Phone number",
      width: 150
    },
    {
      field: "email",
      headerName: "Email",
      width: 150
    },
    {
      field: "movieTitle",
      headerName: "Movie",
      width: 280,
      renderCell: params => {
        return (
          <div className={classes.movieCol}>
            {/* <img
              className={classes.movieImg}
              alt={params.row.movieTitle}
              src={params.row.image_url || empty}
              width={34}
              height={34}
            /> */}
            <p>{params.row.movie_title}</p>
          </div>
        );
      }
    },
    {
      field: "guest_count",
      headerName: "Guest",
      width: 120
    },
    {
      field: "payment_amount",
      headerName: "Amount",
      width: 120
    },
    {
      field: "date_time",
      headerName: "Date",
      width: 200
    },
    {
      field: "",
      headerName: "Status",
      width: 120,
      renderCell: params =>
        params.row.status === BOOKING_STATUS["cancelled"][0] ? (
          <button
            onClick={() => {
              setBooking(params.row);
              setShowApproveDialog(true);
            }}
            className={classes.approve}
          >
            Approve
          </button>
        ) : (
          <p className={classes.cancel}>Cancelled</p>
        )
    },
    {
      field: "view",
      headerName: "View Details",
      width: 200,
      renderCell: params => (
        <button
          onClick={() => {
            setShowDetails(true);
            setBooking(params.row);
          }}
          className={classes.view}
        >
          View more
        </button>
      )
    }
  ];

  const approveCancelation = async () => {
    const res = await cubeApi.editStatus(jwt, booking.booking_id, {
      status: BOOKING_STATUS["cancelled"][1]
    });
    loadBooking();
    setShowApproveDialog(false);
    return res;
  };

  return (
    <div>
      <BookingDetails
        booking={booking}
        open={showDetails}
        handleClose={() => setShowDetails(false)}
        action={
          booking.status === BOOKING_STATUS["cancelled"][1] ? null : (
            <Button
              onClick={() => setShowApproveDialog(true)}
              className={`${classes.formBtn} ${classes.successBtn}`}
              variant="outlined"
              color="primary"
            >
              APPROVE CANCELLATION
            </Button>
          )
        }
      />
      <ConfirmDialog
        btnText="YES, CANCEL"
        btnType="danger"
        handleBtnClick={approveCancelation}
        handleClose={() => setShowApproveDialog(false)}
        message={`Are you sure you want to cancel the cube booking for ${booking.email}`}
        open={showApproveDialog}
        title="Approve Cube Booking Cancellation"
      />
      <DataGrid
        rows={data}
        columns={columns}
        pageSize={15}
        rowHeight={50}
        headerHeight={60}
        disableColumnMenu={true}
        autoHeight={true}
        className="bookings-table"
        loading={loading}
      />
    </div>
  );
};

export default CancelledBookings;
